import AnalyticsPageContainer from "../../analytics/components/AnalyticsPageContainer"
import CustomersContainer from "../../customers/components/CustomersContainer"
import CustomersHubContainer from "../../customers-hub/components/CustomersHubContainer"
import CustomerDetailContainer from "../../customer-detail/components/CustomerDetailContainer"
import ListCustomersContainer from "../../list-customers/components/ListCustomersContainer"
import CustomerManagerContainer from "../../customers-manager/components/CustomerManagerContainer"
import UserContainer from "../../user-manager/components/UserContainer"
import ListContactContainer from "../../manager-contact/components/ListContactContainer"
import BalanceManagerContainer from "../../user-information/balance-manager/components/BalanceManagerContainer"
import ChangePasswordContainer from "../../user-information/change-password/components/ChangePasswordContainer"
import FollowMeContainer from "../../user-information/follow-me/components/FollowMeContainer"
import InformationContainer from "../../user-information/information/components/InformationContainer"
import ResetPassword from "../../user-information/reset-password/components/ResetPassword"
import SettingLayoutContainer from "../../setting-layout/components/SettingLayoutContainer"
import SettingTenantContainer from "../../setting-tenant/components/SettingTenantContainer"
import SettingRoleContainer from "../../setting-role/components/SettingRoleContainer"
import SettingTenantDealerContainer from "../../setting-tenant-agency/components/SettingTenantDealerContainer"
import ReportHubPhoneNumberContainer from "../../report-hub-phone-number/components/ReportHubPhoneNumberContainer"
import ReportCallFeeContainer from "../../report-call-fee/components/ReportCallFeeContainer"
import ReportCallFeeT1Container from "../../report-call-fee-t-1/components/ReportCallFeeT1Container"
import CheckHotlineContainer from "../../check-hotline/components/CheckHotlineContainer"
import PhoneNumberHubContainer from "../../phone-number-hub/components/PhoneNumberHubContainer"
import ReportHubCustPhoneContainer from "../../report-hub-custom-phone/components/ReportHubCustPhoneContainer"
import ReportHubCustPhoneContainerV2 from "../../report-hub-custom-phone-v2/components/ReportHubCustPhoneContainerV2"
import ReportDetailSubContainer from "../../report-detail-sub/components/ReportDetailSubContainer"
import ReportBenefitContainer from "../../report-commission/components/ReportBenefitContainer"
import ReportCallDetailContainer from "../../report-call-detail/components/ReportCallDetailContainer"

export const Routers = [
    {
        path: '/analytics',
        components: AnalyticsPageContainer,
        exact: true,
        role: ''
    },
    {
        path: '/customers',
        components: CustomersContainer,
        exact: true,
        role: 'menu.customer.customer'
    },
    {
        path: '/customers-hub',
        components: CustomersHubContainer,
        exact: true,
        role: 'menu.customerhub'
    },
    {
        path: '/customers/:id',
        components: CustomerDetailContainer,
        exact: true,
        role: 'menu.customer.customer'
    },
    {
        path: '/list-customers',
        components: ListCustomersContainer,
        exact: true,
        role: 'menu.customer.customerList'
    },
    {
        path: '/list-customers/:id',
        components: CustomerManagerContainer,
        exact: true,
        role: ''
    },
    {
        path: '/manager-user',
        components: UserContainer,
        exact: true,
        role: 'menu.setting.user'
    },
    {
        path: '/manager-contact',
        components: ListContactContainer,
        exact: true,
        role: ''
    },
    {
        path: '/balance-manager',
        components: BalanceManagerContainer,
        exact: true,
        role: 'menu.user.billing'
    },
    {
        path: '/users',
        components: ChangePasswordContainer,
        exact: true,
        role: ''
    },
    {
        path: '/users/change-password',
        components: ChangePasswordContainer,
        exact: true,
        role: 'menu.user.userSetting'
    },
    {
        path: '/users/follow-me',
        components: FollowMeContainer,
        exact: true,
        role: 'menu.user.followMe'
    },
    {
        path: '/users/information-user',
        components: InformationContainer,
        exact: true,
        role: 'menu.user.userSetting'
    },
    {
        path: '/balance-manager',
        components: BalanceManagerContainer,
        exact: true,
        role: 'menu.user.billing'
    },
    {
        path: '/users/reset-password',
        components: ResetPassword,
        exact: true,
        role: 'menu.user.userSetting'
    },
    {
        path: '/setting-layout',
        components: SettingLayoutContainer,
        exact: true,
        role: 'menu.setting.layout'
    },
    {
        path: '/setting-tenant',
        components: SettingTenantContainer,
        exact: true,
        role: 'menu.setting.tenantParam'
    },
    {
        path: '/setting-role',
        components: SettingRoleContainer,
        exact: true,
        role: 'menu.setting.role'
    },
    {
        path: '/setting-tenant-dealer',
        components: SettingTenantDealerContainer,
        exact: true,
        role: 'menu.setting.tenantDealer'
    },
    {
        path: '/report-hub-phone-number',
        components: ReportHubPhoneNumberContainer,
        exact: true,
        role: 'menu.report.hubPhoneNumber'
    },
    {
        path: '/report-call-fee',
        components: ReportCallFeeContainer,
        exact: true,
        role: 'menu.report.call.fee'
    },
    {
        path: '/report-call-fee-new',
        components: ReportCallFeeT1Container,
        exact: true,
        role: 'menu.report.call.fee.new'
    },
    {
        path: '/check-hotline-number',
        components: CheckHotlineContainer,
        exact: true,
        role: 'menu.hotline.checkHotline'
    },
    {
        path: '/phone-number-hub',
        components: PhoneNumberHubContainer,
        exact: true,
        role: 'menu.manage.phoneNumber'
    },
    {
        path: '/report-hub-cust-phone',
        components: ReportHubCustPhoneContainer,
        exact: true,
        role: 'menu.report.hub.CustPhone'
    },
    {
        path: '/report-hub-cust-phone-v2',
        components: ReportHubCustPhoneContainerV2,
        exact: true,
        role: 'menu.report.hub.CustPhone.v2'
    },
    {
        path: '/report-detail-sub',
        components: ReportDetailSubContainer,
        exact: true,
        role: 'menu.report.hub.sub.detail'
    },
    {
        path: '/report-benefit',
        components: ReportBenefitContainer,
        exact: true,
        role: 'menu.report.benefit.by.sale'
    },
    {
        path: '/report-call-detail',
        components: ReportCallDetailContainer,
        exact: true,
        role: 'menu.customerhub.reportVoicemail'
    },
]